import { fetchAccessibleTeams, type AccessibleTeam } from "@/team-dashboard/api/team-access-api";
import { useQuery } from "@tanstack/react-query";

export function useAccessibleTeams(department = "sales") {
  return useQuery({
    queryKey: ["accessible-teams", department],
    queryFn: () => fetchAccessibleTeams(department),
    staleTime: 5 * 60_000,
  });
}

export function findAccessibleTeamBySlug(
  teams: AccessibleTeam[] | undefined,
  slug: string,
): AccessibleTeam | undefined {
  if (!teams) return undefined;
  return teams.find((team) => teamSlugMatches(team.teamName, slug));
}

function teamSlugMatches(teamName: string, slug: string): boolean {
  return (
    teamName
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "") === slug
  );
}
